module.exports = __WEBPACK_EXTERNAL_MODULE__apollo_client__;